import IIntegrationData from './IIntegrationData'
import IShelter from './IShelter'
import IBranch from './IBranch'
import IIntegrationSync from './IIntegrationSync'

export const PartnerKeyTypeArray = ['ANIMALS_FIRST', 'CHAMELEON', 'CHAMELEON_DALLAS', 'LIFELINE', 'PETFINDER', 'PETPOINT', 'SHELTER_BUDDY', 'SHELTER_LUV', 'SHELTER_MANAGER'] as const
export type PartnerKeyType = typeof PartnerKeyTypeArray[number]

export default interface IIntegration {
  uuid: string,
  version: number,
  active: boolean,
  partner_key: PartnerKeyType,
  json: IIntegrationData,
  shelter?: IShelter,
  branch?: IBranch,
  integration_syncs?: IIntegrationSync[],
  last_sync: string,
  forced_sync: boolean,
  has_settings: boolean,
  main: boolean
  description?: string
}
